export interface MediaLibraryFilters {
  year: string;
  sourceId: string;
}

export const DEFAULT_MEDIA_LIBRARY_FILTERS: MediaLibraryFilters = {
  year: 'all',
  sourceId: 'all'
};
